import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";

export const exportUserPosToExcel = async (
    json = [],
    filters = {}
) => {
    try {
        if (!Array.isArray(json) || json.length === 0) {
            throw new Error(
                "Tidak ada data pada outlet dan periode yang dipilih"
            );
        }

        const headers = [
            "No",
            "Customer Name",
            "Phone",
            "Total Point Customer",
            "Transaction Code",
            "Transaction Date",
            "Grand Total",
            "Payment Method",
            "Device Payment",
            "Outlet Name",
            "Outlet Address",
            "Point Earned",
            "Point Redeem",
            "Voucher Price",
            "Product Name",
            "Qty",
            "Price",
            "Subtotal",
        ];

        const rows = [];
        const mergeRanges = [];

        let transactionNumber = 1;

        json.forEach((user) => {
            const transactions = Array.isArray(
                user?.transactions
            )
                ? user.transactions
                : [];

            transactions.forEach((transaction) => {
                const products = Array.isArray(
                    transaction?.transaction_products
                )
                    ? transaction.transaction_products
                    : [];

                const productRows =
                    products.length > 0
                        ? products
                        : [
                            {
                                product: {
                                    product_name: "-",
                                },
                                qty: 0,
                                price: 0,
                                subtotal: 0,
                            },
                        ];

                const startRow = rows.length + 5;
                const endRow =
                    startRow + productRows.length - 1;

                productRows.forEach((product, productIndex) => {
                    const isFirstProduct = productIndex === 0;

                    rows.push([
                        isFirstProduct ? transactionNumber : null,
                        isFirstProduct ? user?.name || "-" : null,
                        isFirstProduct ? formatPhone(user?.phone) : null,
                        isFirstProduct ? Number(user?.point || 0) : null,
                        isFirstProduct
                            ? transaction?.transaction_code || "-"
                            : null,
                        isFirstProduct
                            ? formatDate(transaction?.created_at)
                            : null,
                        isFirstProduct
                            ? Number(transaction?.grand_total || 0)
                            : null,
                        isFirstProduct
                            ? transaction?.payment_method || "-"
                            : null,
                        isFirstProduct
                            ? transaction?.device_payment || "-"
                            : null,
                        isFirstProduct
                            ? transaction?.outlet?.outlet_name || "-"
                            : null,
                        isFirstProduct
                            ? cleanAddress(transaction?.outlet?.address)
                            : null,
                        isFirstProduct
                            ? Number(transaction?.point?.point || 0)
                            : null,
                        isFirstProduct
                            ? Number(transaction?.point_redeem || 0)
                            : null,
                        isFirstProduct
                            ? Number(transaction?.voucher_price || 0)
                            : null,

                        // Data produk tetap satu baris per produk.
                        product?.product?.product_name || "-",
                        Number(product?.qty || 0),
                        Number(product?.price || 0),
                        Number(product?.subtotal || 0),
                    ]);
                });

                /*
                 * Merge kolom informasi transaksi jika
                 * transaksi memiliki lebih dari satu produk.
                 *
                 * Kolom 0-13 adalah informasi transaksi.
                 * Kolom 14-17 adalah informasi produk.
                 */
                if (productRows.length > 1) {
                    for (let column = 0; column <= 13; column += 1) {
                        mergeRanges.push({
                            s: {
                                r: startRow,
                                c: column,
                            },
                            e: {
                                r: endRow,
                                c: column,
                            },
                        });
                    }
                }

                transactionNumber += 1;
            });
        });

        if (rows.length === 0) {
            throw new Error(
                "Tidak ada transaksi sesuai filter"
            );
        }

        const outletText =
            filters?.outletNames?.length > 0
                ? filters.outletNames.join(", ")
                : "-";

        const periodText =
            filters?.startDate && filters?.endDate
                ? `${filters.startDate} sampai ${filters.endDate}`
                : "-";

        const worksheetData = [
            ["DATA TRANSAKSI MEMBERSHIP"],
            [`Outlet: ${outletText}`],
            [`Periode: ${periodText}`],
            [],
            headers,
            ...rows,
        ];

        const ws =
            XLSX.utils.aoa_to_sheet(worksheetData);

        const lastColumn = headers.length - 1;
        const lastRow = worksheetData.length - 1;

        ws["!merges"] = [
            {
                s: { r: 0, c: 0 },
                e: { r: 0, c: lastColumn },
            },
            {
                s: { r: 1, c: 0 },
                e: { r: 1, c: lastColumn },
            },
            {
                s: { r: 2, c: 0 },
                e: { r: 2, c: lastColumn },
            },
            ...mergeRanges,
        ];

        ws["!cols"] = [
            { wch: 6 },
            { wch: 24 },
            { wch: 18 },
            { wch: 20 },
            { wch: 24 },
            { wch: 21 },
            { wch: 18 },
            { wch: 20 },
            { wch: 20 },
            { wch: 26 },
            { wch: 42 },
            { wch: 16 },
            { wch: 16 },
            { wch: 18 },
            { wch: 32 },
            { wch: 10 },
            { wch: 18 },
            { wch: 18 },
        ];

        ws["!rows"] = [
            { hpt: 28 },
            { hpt: 22 },
            { hpt: 22 },
            { hpt: 8 },
            { hpt: 28 },
        ];

        const thinBorder = {
            top: {
                style: "thin",
                color: { rgb: "000000" },
            },
            bottom: {
                style: "thin",
                color: { rgb: "000000" },
            },
            left: {
                style: "thin",
                color: { rgb: "000000" },
            },
            right: {
                style: "thin",
                color: { rgb: "000000" },
            },
        };

        /*
         * Style judul.
         */
        ws["A1"].s = {
            font: {
                bold: true,
                sz: 16,
            },
            alignment: {
                horizontal: "center",
                vertical: "center",
            },
            fill: {
                fgColor: {
                    rgb: "D9EAF7",
                },
            },
            border: thinBorder,
        };

        /*
         * Style outlet dan periode.
         */
        ["A2", "A3"].forEach((cellAddress) => {
            ws[cellAddress].s = {
                font: {
                    bold: true,
                    sz: 11,
                },
                alignment: {
                    horizontal: "left",
                    vertical: "center",
                },
                fill: {
                    fgColor: {
                        rgb: "EAF2F8",
                    },
                },
                border: thinBorder,
            };
        });

        /*
         * Merge cell hanya menyimpan style pada cell awal.
         * Tambahkan border untuk seluruh area judul.
         */
        for (
            let rowIndex = 0;
            rowIndex <= 2;
            rowIndex += 1
        ) {
            for (
                let columnIndex = 0;
                columnIndex <= lastColumn;
                columnIndex += 1
            ) {
                const address =
                    XLSX.utils.encode_cell({
                        r: rowIndex,
                        c: columnIndex,
                    });

                if (!ws[address]) {
                    ws[address] = {
                        t: "s",
                        v: "",
                    };
                }

                ws[address].s = {
                    ...(ws[address].s || {}),
                    border: thinBorder,
                    alignment: {
                        vertical: "center",
                        horizontal:
                            rowIndex === 0
                                ? "center"
                                : "left",
                    },
                };
            }
        }

        /*
         * Style header tabel.
         */
        for (
            let columnIndex = 0;
            columnIndex <= lastColumn;
            columnIndex += 1
        ) {
            const address =
                XLSX.utils.encode_cell({
                    r: 4,
                    c: columnIndex,
                });

            ws[address].s = {
                font: {
                    bold: true,
                    color: {
                        rgb: "FFFFFF",
                    },
                },
                fill: {
                    fgColor: {
                        rgb: "4472C4",
                    },
                },
                alignment: {
                    horizontal: "center",
                    vertical: "center",
                    wrapText: true,
                },
                border: thinBorder,
            };
        }

        /*
         * Border dan alignment seluruh isi tabel.
         */
        for (
            let rowIndex = 5;
            rowIndex <= lastRow;
            rowIndex += 1
        ) {
            for (
                let columnIndex = 0;
                columnIndex <= lastColumn;
                columnIndex += 1
            ) {
                const address =
                    XLSX.utils.encode_cell({
                        r: rowIndex,
                        c: columnIndex,
                    });

                if (!ws[address]) {
                    ws[address] = {
                        t: "s",
                        v: "",
                    };
                }

                ws[address].s = {
                    border: thinBorder,
                    alignment: {
                        vertical: "center",
                        horizontal: getAlignment(
                            columnIndex
                        ),
                        wrapText: true,
                    },
                };

                /*
                 * Format angka.
                 */
                if (
                    [
                        3,
                        6,
                        11,
                        12,
                        13,
                        15,
                        16,
                        17,
                    ].includes(columnIndex) &&
                    typeof ws[address].v === "number"
                ) {
                    ws[address].z = "#,##0";
                }
            }
        }

        ws["!autofilter"] = {
            ref: `A5:${XLSX.utils.encode_col(
                lastColumn
            )}${lastRow + 1}`,
        };

        ws["!freeze"] = {
            xSplit: 0,
            ySplit: 5,
            topLeftCell: "A6",
            activePane: "bottomLeft",
            state: "frozen",
        };

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(
            wb,
            ws,
            "Data Membership"
        );

        const buffer = XLSX.write(wb, {
            bookType: "xlsx",
            type: "array",
            cellStyles: true,
        });

        const blob = new Blob([buffer], {
            type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileName =
            `Data_Membership_` +
            `${filters.startDate || "all"}_` +
            `${filters.endDate || "all"}.xlsx`;

        saveAs(blob, fileName);
    } catch (error) {
        console.error("Export failed:", error);
        throw error;
    }
};

const formatDate = (value) => {
    if (!value) {
        return "-";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return String(value);
    }

    return date.toLocaleString("id-ID", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
};

const cleanAddress = (value) => {
    if (!value) {
        return "-";
    }

    return String(value)
        .replace(/\r?\n|\r/g, ", ")
        .replace(/\s+/g, " ")
        .trim();
};

const formatPhone = (value) => {
    if (!value) {
        return "-";
    }

    return String(value);
};

const getAlignment = (columnIndex) => {
    const centerColumns = [
        0,
        2,
        4,
        5,
        7,
        8,
        11,
        12,
        13,
        15,
    ];

    const rightColumns = [
        3,
        6,
        16,
        17,
    ];

    if (centerColumns.includes(columnIndex)) {
        return "center";
    }

    if (rightColumns.includes(columnIndex)) {
        return "right";
    }

    return "left";
};